import React from 'react';

const PatientDetailItem = ({ label, value }) => {
    if (!value) return null;

    return (
        <div className='flex items-center gap-2'>
            <p>{label}:</p>
            <p>{value}</p>
        </div>
    );
};

export default PatientDetailItem;